/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type userStorageActions$ref = any;
export type userStorageActions = {
    readonly isVerifiedTrade: boolean | null;
    readonly isVip: boolean | null;
    readonly " $refType": userStorageActions$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "userStorageActions",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVip",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'b731139716173823ea17c3fbc263b857';
export default node;
